export enum CardStatus {
  ACTIVE = 'Active',
  NEW = 'New',
  CANCELED = 'Canceled',
  IN_PROCESS = 'In Process',
  ORDERED = 'Ordered',
  FROZEN = 'Frozen',
  VOID = 'Void',
  APPROVED = 'Approved',
}

export interface Card {
  id: string;
  customer: string;
  url?: string;
  account: string;
  cardType: string;
  paymentSystem: string;
  pan: string;
  status: CardStatus;
  balance?: string;
  type?: 'individual' | 'corporate';
  expairedDate?: string;
  address?: string;
  currency?: string;
  virtual?: boolean;
  countryId?: string;
  city?: string;
  postCode?: string;
  street?: string;
  apartment?: string;
  availableStatuses?: {
    name: string;
    value: CardStatus;
  }[];
  render?: Record<string, React.JSX.Element>;
}

export interface OrderCardFormValues {
  userId: string;
  physical?: boolean;
  cardType?: string;
  paymentSystem: string;
  countryId?: string;
  city?: string;
  postCode?: string;
  street?: string;
  apartment?: string;
  countryName?: string;
}

export enum TransactionDescription {
  CHARGEBACK = 'Chargeback',
  CREDIT = 'Credit',
  DEBIT = 'Debit',
  VOID = 'Void',
  REFUND = 'Refund',
}

export interface Transaction {
  id: string;
  date: string;
  url?: string;
  description: TransactionDescription;
  currency: string;
  amount: string;
  amountBc: string;
  bc?: string;
  merchantName: string;
  terminalId: string;
  orderDetails: string;
  fraud?: boolean;
  render?: Record<string, React.JSX.Element>;
}

export interface Customer {
  id: string;
  firstName: string;
  lastName: string;
}
